var map = {
	"./": [
		81
	],
	"./components/TriviaExitPopup": [
		285,
		9
	],
	"./components/TriviaExitPopup.tsx": [
		285,
		9
	],
	"./icons/CloseIcon": [
		148
	],
	"./icons/CloseIcon.tsx": [
		148
	],
	"./icons/FullIcon": [
		282,
		10
	],
	"./icons/FullIcon.tsx": [
		282,
		10
	],
	"./icons/MenuIcon": [
		286,
		11
	],
	"./icons/MenuIcon.tsx": [
		286,
		11
	],
	"./icons/XIcon": [
		287,
		12
	],
	"./icons/XIcon.tsx": [
		287,
		12
	],
	"./index": [
		81
	],
	"./index.tsx": [
		81
	],
	"./text.style": [
		283,
		13
	],
	"./text.style.ts": [
		283,
		13
	],
	"./types": [
		131
	],
	"./types.ts": [
		131
	],
	"./v1": [
		164,
		3
	],
	"./v1/": [
		164,
		3
	],
	"./v1/index": [
		164,
		3
	],
	"./v1/index.tsx": [
		164,
		3
	],
	"./v2": [
		168,
		2
	],
	"./v2/": [
		168,
		2
	],
	"./v2/index": [
		168,
		2
	],
	"./v2/index.tsx": [
		168,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 432;
module.exports = webpackAsyncContext;